import { styled } from "@mui/material";

import { DefaultText } from ".";

export const TitleText = styled(DefaultText)(() => ({
  fontWeight: "bold",
}));
